import MatomoMessage from '@/matomo/message/MatomoMessage';
import { MatomoActions } from '@/matomo/MatomoActions';

export default class MatomoSearchPageVisit {
  private setCustomUrl: MatomoMessage;
  private trackPageView = new MatomoMessage([MatomoActions.trackPageView]);

  public static withSearchCount(numberOfElementsFound: number): MatomoSearchPageVisit {
    return new MatomoSearchPageVisit(document.URL + '&search_count=' + numberOfElementsFound);
  }

  private constructor(url: string) {
    this.setCustomUrl = new MatomoMessage([MatomoActions.setCustomUrl, url]);
  }

  public publishPageVisit() {
    this.setCustomUrl.publish();
    this.trackPageView.publish();
  }


}
